import { useEffect } from 'react';
import { ECharts } from 'echarts/lib/echarts';

export default (
  chartInstance: ECharts | null,
  dateRange: number[],
  originalPoints: {
    startPoint: number,
    endPoint: number,
  },
) => {
  useEffect(() => {
    if (chartInstance && dateRange.length && originalPoints) {
      // Restore previous saved config startTime and endTime for the 1st render
      // to restore brush slice on chart
      // This action will emit 'globalcursortaken' on events
      const { startPoint, endPoint } = originalPoints;
      chartInstance.dispatchAction({
        type: 'dataZoom',
        start: startPoint,
        end: endPoint,
      });
    }
  }, [chartInstance, dateRange, originalPoints]);
};
